import type React from 'react';
import { FormattedMessage, type MessageDescriptor } from 'react-intl';

type FormattedMessageProps = React.ComponentProps<typeof FormattedMessage>;

type FormattedTagProps = MessageDescriptor & {
  tagName?: FormattedMessageProps['tagName'];
  values?: FormattedMessageProps['values'];
  onClick?: (e: React.SyntheticEvent<HTMLDivElement>) => void;
  role?: string;
  className?: string;
  isHtml?: boolean;
};

export const FormattedTag: React.FC<FormattedTagProps> = ({
  tagName: Tag = 'span',
  className,
  id,
  values,
  defaultMessage,
  isHtml,
  ...props
}) => (
  <FormattedMessage id={id} defaultMessage={defaultMessage} values={values}>
    {(txt) =>
      isHtml ? (
        <Tag className={className} {...props} dangerouslySetInnerHTML={{ __html: txt }} />
      ) : (
        <Tag className={className} {...props}>
          {txt}
        </Tag>
      )
    }
  </FormattedMessage>
);
